<template>
    <div class="footer">
        <div class="footer__inner">
            <p v-html="$t('footer.address')" class="address"></p>
            <p v-html="$t('footer.copyright')" class="copyright"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
.footer {
    width: 100%;
    height: 90px;
    background: #efefef;
    color: #999;
    font-size: 13px;
    @include over-desktop {
        &__inner {
            position: relative;
            width: 1200px;
            height: 100%;
            margin: 0 auto;

            .address {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
            }
            .copyright {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
            }
        }
    }
    @include desktop-small {
        &__inner {
            width: 1024px;
            .address {
                left: 28px;
            }
            .copyright {
                right: 28px;
            }
        }
    }
    @include under-tablet {
        position: relative;
        height: 30vw;
        &__inner {
            position: absolute;
            top: 50%;
            left: 28px;
            width: 100%;
            font-size: 3vw;
            transform: translateY(-50%);
            .copyright {
                margin-top: 3vw;
            }
        }
    }
    @include mobile {
        &__inner {
            left: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue